'use client';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Fragment } from 'react';
import { RESPONSIVE_MARGIN } from '@/functions/createTheme';
import { EventCard } from './EventCard';
import { useEventCardList } from './hooks';

type Props = {
  events: ImEventDto[];
  count: number;
  searchParams: SearchParams;
  customerSetting: CustomerSetting;
};

export const EventCardList: React.FC<Props> = ({
  events,
  count,
  searchParams,
  customerSetting
}) => {
  const theme = useTheme();
  const { searchQueryText, ref, createLink } = useEventCardList(
    searchParams,
    customerSetting
  );

  return (
    <Box sx={{ my: RESPONSIVE_MARGIN }}>
      <Box ref={ref} sx={{ my: 1 }}>
        <Typography
          component="h2"
          variant="h5"
          sx={{
            fontSize: {
              xs: theme.typography.h6.fontSize,
              sm: theme.typography.h5.fontSize
            }
          }}
        >
          {searchQueryText}
          {` ${count}件`}
          {searchParams.page && `（${searchParams.page}ページ目）`}
        </Typography>
      </Box>
      <Divider />
      {events.map((imEvent, i) => {
        return (
          <Fragment key={`event-${i}`}>
            <EventCard imEvent={imEvent} customerSetting={customerSetting} />
            <Divider />
          </Fragment>
        );
      })}
      <Box
        sx={{
          my: RESPONSIVE_MARGIN,
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <Pagination
          count={Math.ceil(count / customerSetting.eventsPerPage)}
          page={parseInt(searchParams.page ?? '1')}
          color="primary"
          renderItem={(item) => (
            <PaginationItem
              {...item}
              component="a"
              href={createLink(item.page)}
            />
          )}
        />
      </Box>
    </Box>
  );
};
